export const dateTimeFormatter = new Intl.DateTimeFormat('de-DE', {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false
});
